import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import editTokens from '@amzn/meridian-tokens/base/icon/edit';
import Icon from '@amzn/meridian/icon';
import Table, { TableCell, TableRow } from '@amzn/meridian/table';
import UncontrolledExpandableRow from 'src/components/shared/uncontrolledExpandableRow/uncontrolledExpandableRow';
import * as LDAP from 'src/config/LDAP';
import {
  setAssociateInfoFormData,
  setIsEditAssociateInfoModalOpen,
  setIsEditAssociateInfoSaving,
} from 'src/store/placementDetailsPageSlice/placementDetailsPageSlice';
import { useAppSelector } from 'src/store/store';

import './employeeInformation.scss';

import EditAssociateInfoModalAUSTIN from './editAssociateInfoModal/editAssociateInfoModalAUSTIN';

interface TableItem {
  label: string;
  value: string | number;
  dataCy: string;
}

const EmployeeInformation = () => {
  const [employeeInformationTableData, setEmployeeInformationTableData] = useState<TableItem[]>([]);
  const { ldap } = useAppSelector((state) => state.user);

  const { placementDetails } = useAppSelector((state) => state.placementDetailsPage);
  const isAdmin = ldap.includes(LDAP.ADMIN);

  const dispatch = useDispatch();

  useEffect(() => {
    if (placementDetails) {
      const items: TableItem[] = [
        {
          label: 'Login',
          value: placementDetails.login,
          dataCy: 'login',
        },
        {
          label: 'Employee ID',
          value: placementDetails.employeeId,
          dataCy: 'employeeID',
        },
        {
          label: 'Person ID',
          value: placementDetails.personId,
          dataCy: 'personID',
        },
        {
          label: 'Job',
          value: placementDetails.job,
          dataCy: 'job',
        },
        {
          label: 'Home Location',
          value: placementDetails.fc,
          dataCy: 'siteLocation',
        },
        {
          label: 'Home Shift',
          value: placementDetails.shiftCode,
          dataCy: 'shift',
        },
      ];

      setEmployeeInformationTableData(items);
    }
  }, [placementDetails]);

  const initializeAndOpenEditAssociateModal = () => {
    dispatch(setIsEditAssociateInfoSaving(false));
    dispatch(
      setAssociateInfoFormData({
        login: placementDetails.login,
        employeeId: placementDetails.employeeId,
        job: placementDetails.job,
        homeLocation: placementDetails.fc,
        homeShift: placementDetails.shiftCode,
        caseId: placementDetails.externalCaseId,
        caseSource: placementDetails.accommodationType,
        fullName: placementDetails.associateFullName,
      }),
    );
    dispatch(setIsEditAssociateInfoModalOpen(true));
  };

  return (
    <>
      <EditAssociateInfoModalAUSTIN />
      <Table
        headerRows={1}
        headerColumns={1}
        rowComponents={[UncontrolledExpandableRow, TableRow]}
        showStripes={true}
        showDividers={true}
      >
        <TableRow>
          <TableCell></TableCell>
          <TableCell>Employee Information</TableCell>
          <TableCell>{isAdmin && <span>Edit</span>}</TableCell>
        </TableRow>
        {employeeInformationTableData.map(({ value, label, dataCy }, index) => (
          <TableRow key={index}>
            <TableCell>{label}</TableCell>
            <TableCell data-cy={`placement-details__home-process__${dataCy}`}>{value}</TableCell>
            <TableCell>
              {label === 'Login' && isAdmin && (
                <span onClick={initializeAndOpenEditAssociateModal} className="employee-info__edit-icon">
                  <Icon tokens={editTokens}></Icon>
                </span>
              )}
            </TableCell>
          </TableRow>
        ))}
      </Table>
    </>
  );
};
export default EmployeeInformation;
